import {
  EditPriceForm,
  ImageUploadInfo,
  Product,
  ProductFormDetailsInterface,
} from 'types/productTypes';
import {
  normalizePrices,
  transformProductForm,
} from 'utils/mappers/productMapper';

import { APIClient } from 'services/helpers/api_helper';

import * as url from 'services/helpers/url_helper';
import {
  dedupeRequest,
  stableRequestKey,
} from 'services/helpers/requestDedupe';
import axios, { AxiosResponse } from 'axios';

import {
  CategoriesResponse,
  DeleteBulkProductResponse,
  GetCheckCompositeResponse,
  GetESProductsResponse,
  GetESProductPaginationIdsResponse,
  GetExportProductsInfoGroupedByStoreResponse,
  GetExportProductsInformationResponse,
  GetExportProductsQuantityResponse,
  GetOneProductResponse,
  PostESProductIdsResponse,
  PostProductsSimpleResponse,
  GetProductPricesByIdResponse,
  GetProductsListLightResponse,
  GetProductsListResponse,
  GetProductsListResponseV2,
  GetProductsListResponseV3,
  PostAddProductResponse,
  PutUpdateProductResponse,
  SuppliersResponse,
} from 'types/APIResponsesTypes';
import { SuccessResponse } from 'types/ResponseTypes';

const api = new APIClient();

export const postAddProduct = async (
  MerchantID: number,
  FormData: ProductFormDetailsInterface,
  imgName: string
) => {
  try {
    const transformedData: Product = transformProductForm(
      FormData,
      imgName,
      MerchantID
    );
    const response: Promise<PostAddProductResponse> = await api.create(
      url.POST_ADD_PRODUCT,
      transformedData
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const putUpdateProduct = async (
  MerchantID: number,
  id: string,
  FormData: ProductFormDetailsInterface,
  imgName: string,
  isDeleteImg: number
) => {
  try {
    const transformedData: Product = transformProductForm(
      FormData,
      imgName,
      MerchantID,
      true,
      isDeleteImg
    );
    const response: Promise<PutUpdateProductResponse> = await api.put(
      url.POST_UPDATE_PRODUCT + id,
      transformedData
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postAddImage = async (
  selectedFile: File
): Promise<SuccessResponse<ImageUploadInfo>> => {
  const formData = new FormData();
  formData.set('image', selectedFile);
  formData.set('filename', selectedFile.name);

  try {
    const response: SuccessResponse<ImageUploadInfo> = await axios.post(
      url.POST_ADD_IMAGE,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
        },
      }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getSearchProductsList = async (
  store_ids: string,
  keyword: string,
  limit = 10,
  page = 1,
  category_id = '',
  quantity_range = '',
  barcode = '',
  supplier_id = ''
  // sort_by = 'item_id',
  // sort_order = 'desc'
) => {
  try {
    const response: Promise<GetProductsListResponse> = await api.get(
      url.GET_PRODUCTS,
      {
        store_ids,
        keyword,
        limit,
        page,
        category_id,
        quantity_range,
        barcode,
        supplier_id,
        // sort_by,
        // sort_order,
      }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getSearchProductsListV2 = async (
  store_ids: string,
  keyword: string,
  limit = 10,
  page = 1,
  category_id = '',
  quantity_range = '',
  barcode = '',
  supplier_id = ''
  // sort_by = 'item_id',
  // sort_order = 'desc'
) => {
  try {
    const response: Promise<GetProductsListResponseV2> = await api.get(
      url.GET_PRODUCTS_V2,
      {
        store_ids,
        keyword,
        limit,
        page,
        category_id,
        quantity_range,
        barcode,
        supplier_id,
        // sort_by,
        // sort_order,
      }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getSearchProductsListV3 = async (
  store_ids: string,
  keyword: string,
  limit = 10,
  page = 1,
  category_id = '',
  quantity_range = '',
  barcode = '',
  code = '',
  supplier_id = '',
  tag_ids: number[] = []
  // sort_by = 'item_id',
  // sort_order = 'desc'
) => {
  try {
    const response: Promise<GetProductsListResponseV3> = await api.get(
      url.GET_PRODUCTS_V3,
      {
        store_ids,
        keyword,
        limit,
        page,
        category_id,
        quantity_range,
        barcode,
        code,
        supplier_id,
        tag_ids,
        // sort_by,
        // sort_order,
      }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getSearchProductsLight = async (
  store_ids: string,
  keyword: string,
  limit = 10,
  page = 1,
  category_id = '',
  quantity_range = '',
  barcode = '',
  code = '',
  supplier_id = '',
  tag_ids: number[] = []
  // sort_by = 'item_id',
  // sort_order = 'desc'
) => {
  try {
    const response: Promise<GetProductsListLightResponse> = await api.get(
      url.GET_PRODUCTS_V3,
      {
        store_ids,
        keyword,
        limit,
        page,
        category_id,
        quantity_range,
        barcode,
        code,
        supplier_id,
        tag_ids,
        // sort_by,
        // sort_order,
      }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getExportProductsInformation = async (
  store_ids: string,
  keyword: string,
  start: number,
  end: number,
  category_id = '',
  quantity_range = '',
  barcode = '',
  supplier_id = ''
  // sort_by = 'item_id',
  // sort_order = 'desc'
) => {
  try {
    const response: Promise<GetExportProductsInformationResponse> =
      await api.get(url.GET_EXPORT_PRODUCTS_INFORMATION, {
        store_ids,
        keyword,
        start,
        end,
        category_id,
        quantity_range,
        barcode,
        supplier_id,
        // sort_by,
        // sort_order,
      });

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getExportProductsInfoGroupedByStore = async (
  store_ids: string,
  keyword: string,
  limit = 10,
  page = 1,
  category_id = '',
  quantity_range = '',
  barcode = '',
  supplier_id = ''
  // sort_by = 'item_id',
  // sort_order = 'desc'
) => {
  try {
    const response: Promise<GetExportProductsInfoGroupedByStoreResponse> =
      await api.get(url.GET_EXPORT_GROUPED_PRODUCTS_INFO, {
        store_ids,
        keyword,
        limit,
        page,
        category_id,
        quantity_range,
        barcode,
        supplier_id,
        // sort_by,
        // sort_order,
      });

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getExportProductsQuantity = async (
  store_ids: string,
  keyword: string,
  start: number,
  end: number,
  category_id = '',
  quantity_range = '',
  barcode = '',
  supplier_id = ''
  // sort_by = 'item_id',
  // sort_order = 'desc'
) => {
  try {
    const response: Promise<GetExportProductsQuantityResponse> = await api.get(
      url.GET_EXPORT_PRODUCTS_QUANTITY,
      {
        store_ids,
        keyword,
        start,
        end,
        category_id,
        quantity_range,
        barcode,
        supplier_id,
        // sort_by,
        // sort_order,
      }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getSearchProductsCategory = async (
  store_ids: string,
  limit = '-1'
) => {
  try {
    const response: Promise<CategoriesResponse> = await api.get(
      url.GET_CATEGORIES,
      {
        store_ids,
        limit,
      }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getSearchSuppliers = async (
  store_ids: string,
  sort_by = 'company_name',
  sort_order = 'asc',
  limit = '-1'
) => {
  try {
    const response: Promise<SuppliersResponse> = await api.get(
      url.GET_SUPPLIERS,
      {
        store_ids,
        sort_by,
        sort_order,
        limit,
      }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getAllProducts = async (storeId: string) => {
  try {
    const response = await api.get(url.GET_PRODUCTS, { storeId });

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getProductById = async (id: string) => {
  try {
    const response: Promise<GetOneProductResponse> = await api.get(
      url.GET_PRODUCTS_BY_ID + id
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const deleteBulkProducts = async (productIds: number[]) => {
  try {
    const body = {
      product_ids: productIds,
    };
    const response: AxiosResponse<DeleteBulkProductResponse> = await api.delete(
      url.DELETE_BULK_PRODUCT,
      {
        data: body,
      }
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteBulkProductsByItemIdNumber = async (
  itemIdNumbers: number[]
) => {
  try {
    const body = {
      item_id_numbers: itemIdNumbers,
    };
    const response: AxiosResponse<DeleteBulkProductResponse> = await api.delete(
      url.DELETE_BULK_PRODUCT,
      {
        data: body,
      }
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const putUpdatePrice = async (FormData: EditPriceForm) => {
  try {
    const convertedFormData = normalizePrices(FormData);
    const response: Promise<SuccessResponse> = await api.put(
      url.PUT_UPDATE_PRICE,
      convertedFormData
    );

    console.log(response);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getProductPricesById = async (id: number, store_id: number) => {
  try {
    const response: Promise<GetProductPricesByIdResponse> = await api.get(
      `${url.GET_PRODUCT_PRICES_BY_ID}${id}`,
      {
        store_id,
      }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getCheckComposite = async (item_id_number: number) => {
  try {
    const response: Promise<GetCheckCompositeResponse> = await api.get(
      `${url.GET_CHECK_COMPOSITE}${item_id_number}`
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export interface ProductESSearchParams {
  name?: string;
  category_number?: number;
  item_id_number?: string;
  item_code?: string;
  supplier_id?: number;
}

export interface ProductESSearchIdsBody {
  item_id_numbers?: number[];
  page: number;
  limit: number;
  sort_by?: string;
  sort_order?: string;
}

export interface ProductSimpleListBody {
  store_ids: number[];
  page: number;
  limit: number;
  item_id_numbers?: number[];
  sort_by?: string;
  sort_order?: string;
}

export const getSearchProductsFromES = async (
  params: ProductESSearchParams,
  limit = 20
) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && v !== null)
    );
    const requestParams = { ...filteredParams, limit };
    const cacheKey = `es-products:${stableRequestKey(requestParams)}`;

    const response: Promise<GetESProductsResponse> = await dedupeRequest(
      cacheKey,
      () => api.get(url.GET_SEARCH_PRODUCT, requestParams)
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postSearchProductIdsFromES = async (
  body: ProductESSearchIdsBody
) => {
  try {
    const response: Promise<PostESProductIdsResponse> = await api.create(
      url.POST_SEARCH_PRODUCT_IDS,
      body
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getSearchProductPaginationIdsFromES = async (
  params: ProductESSearchParams,
  page = 1,
  limit = 25
) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== '' && v !== null
      )
    );
    const response: Promise<GetESProductPaginationIdsResponse> = await api.get(
      url.GET_SEARCH_PRODUCT_PAGINATION_IDS,
      { ...filteredParams, page, limit }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postProductsSimple = async (body: ProductSimpleListBody) => {
  try {
    const response: Promise<PostProductsSimpleResponse> = await api.create(
      url.POST_PRODUCTS_SIMPLE,
      body
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
